<app-banner [heading]="'OUR INFRA - INDOOR GAMES'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
   
    
    <!-- ======= About Section ======= -->
    <section id="about" class="about">

      <div class="container">
        <div class="row">

          <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/indoorgames/indoor-games-1.jpg" alt="best school in kurukshetra">
            </div>
          </div>

          <div class="col-lg-6 col-md-6">
            <div class="about-content">
              <h6 class=""> Indoor Games</h6>
              
              <p>Sports help in the development of a student’s confidence and mental health. They are also 
			  beneficial for physical fitness.<br><br> Sports like Skating, Chess,  carrom and Table-tennis etc. help keep the mind
			  and body active. They also improve concentration and stimulate the body’s natural immune system.<br><br>
			  At <b>Tagore Global School</b>, we have indoor and outdoor sports facilities for students and we offer wide variety 
			  of co-curricular as well as after school activities.
			  
			  </p>
              
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/indoorgames/indoor-games-2.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/indoorgames/indoor-games-3.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/indoorgames/indoor-games-4.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-6 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/indoorgames/indoor-games-5.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		  <div class="col-lg-12 col-md-6">
            <div class="about-img">
              <img src="assets/img/infra/indoorgames/indoor-games-6.jpg" alt="best school in kurukshetra">
            </div>
          </div>
		 
		  
		</div>
      </div>
	</section><!-- End About Section -->
	

	
	
    
    
  </main>